<div class="card-header">
  <span *ngIf="header" class="card-title">{{ header | translate }}</span>
  <span *ngIf="subheader" class="card-subtitle">{{ subheader | translate }}</span>
  <ng-content select="[card-header]"></ng-content>
</div>
<div class="card-body">
  <ng-content></ng-content>
</div>
<div class="card-footer">
  <ng-content select="[card-footer]"></ng-content>
</div>
